// §2.8 «Before Payment»: before the handover the four card screens show a
// dedicated empty-state copy — the cards come after payment, and the first
// cards are built from the pre-payment conversation. The product copy lives
// in the frontend; the register mirrors each screen's standard empty text.
export const BEFORE_PAYMENT_EMPTY: Record<
  'quotes' | 'themes' | 'strengths' | 'self_view',
  string
> = {
  quotes:
    'Здесь появятся твои цитаты после оплаты — первые соберём из твоей переписки до подключения.',
  themes:
    'Здесь появятся темы после оплаты — первую соберём из вашей переписки до подключения.',
  strengths:
    'Сильные стороны и ресурсы появятся после оплаты — первую соберём из вашей переписки до подключения.',
  self_view:
    'Здесь появится самоописание после оплаты — первое соберём из вашей переписки до подключения.',
}
